import { useEffect, useCallback, useRef } from "react";
import { useRouter } from "next/router";

type UserJourneyEvent = {
  uid: string;
  page: string;
  url: string;
  action: string;
  api_payload?: any;
  api_response?: any;
  api_error?: boolean;
  sid?: string | number | null;
};

export function useUserJourney(uid: string) {
  const router = useRouter();
    const lastTrackedPath = useRef<string | null>(null);


  const trackEvent = useCallback(
    async (event: Omit<UserJourneyEvent, "uid">) => {
      try {
        const payload: UserJourneyEvent = {
          uid,
          api_error: false,
          ...event,
        };

        await fetch("/api/user/user-journey", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } catch (err) {
        console.error("⚠️ Error sending user journey event:", err);
      }
    },
    [uid]
  );
const getFullUrl = () => {
    if (typeof window !== "undefined") {
      return window.location.href;  
    }
    return router.asPath;  
  };
  useEffect(() => {
    const handleRouteChange = (url: string) => {
            const currentPath = router.pathname;
  if (router.pathname !== lastTrackedPath.current) {
      trackEvent({
        page: router.pathname.replace("/", "") || "home",
        url: getFullUrl(),
        action: "page-load",
      });
      lastTrackedPath.current = router.pathname;
    }
        };

    //   trackEvent({
    //     page: router.pathname.replace("/", "") || "home",
    //     url: getFullUrl(),
    //     action: "page-load",
    //   });
    // };

    // // Initial load
    // handleRouteChange(window.location.href);

    // Subscribe to route changes
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  return { trackEvent ,  getFullUrl };
}
